export default "__VITE_ASSET__0c9c0d69__"